module.exports = __webpack_public_path__ + "static/media/vista.d5a88e67.png";